import React from "react";

export function Col({ children }) {
  return <div style={$.col}>{children}</div>;
}

Col.C = function ColC({ children }) {
  return <div style={$.colC}>{children}</div>;
};

const $ = {
  col: {
    display: "flex",
    flexDirection: "column",
  },
  colC: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};
